import styledTheme from 'common/theme';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const NavContainer = styled.div`
    margin: 2rem 2rem 1.25rem;
`
const MachineViewContainer = styled.div`
    margin: 1rem 2rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    margin: 2rem;
    justify-content: center;
`
const CardContent = styled(Link)`
    background-color: ${styledTheme.colors.white};
    height: 12.5rem;
    margin-top: .5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-decoration: none;
`
const MachineImage = styled.div`
    width: 12rem;
    height: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
`
const Img = styled.img`
    max-width: 100%;
    height: 100%;
    object-fit: contain;
`
const MachineName = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    text-decoration: none;
    .machine-name{
        width: 8rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
    }
    .icon--chevron-right{
        color: black;
    }
`
const PartsTableContainer = styled.div`
  margin: 0rem 2rem;
`;
const SubHeading = styled.div`
  border-bottom: 1px solid ${styledTheme.colors.gray300};
`;
const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const RequestPriceHeader = styled.div`
  margin-bottom: 1rem;
`
const ContactFormModal = styled.div`
  .modal-content {
    padding: 0;
  }
`;
const CartIconBtn = styled.button`
    all: unset;
    cursor: pointer;    
`
const TableContainer = styled.div`
  font-size: 14px;
  .parts-table {
    max-height: calc(100vh - 20rem);

    .globalSearchInput {
      width: 15rem;
    }
    table td {
        width: 12rem;
      padding: 0.4rem 0.625rem;
    }
    table tr {
      height: 2rem;
    }
    tr th{
      &:first-child {
        max-width: 1%;
        word-break: break-all;
      }
    }
    tr td {
      &:first-child {
        max-width: 1%;
        width: 1%;
        word-break: break-all;
      }
    }
  }
  .part-price {
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
  }
  .standard-price {
    order: 2;
    font-size: 0.875rem;
  }
  .customer-price {
    font-size: 0.875rem;
  }
  .product{
    max-width: 12rem;
    min-width: 12rem;
  }
`;
export {
  NavContainer,
  MachineViewContainer,
  CardContent,
  MachineImage,
  MachineName,
  Img,
  PartsTableContainer,
  CartIconBtn,
  TableContainer,
  SubHeading,
  ModalContent,
  RequestPriceHeader,
  ContactFormModal
};
